import React from 'react';
import PropTypes from 'prop-types';

import { PORCELAIN, SILVER_SAND } from '@constant/colors';

const MailClient = ({ className }) => (
  <svg
    viewBox="0 0 470 409"
    preserveAspectRatio="xMinYMin slice"
    className={className}
  >
    <defs>
      <pattern
        id="mailclient-pattern"
        patternUnits="objectBoundingBox"
        y="-16.966967%"
        height="116.966967%"
        width="100%"
      >
        <use transform="scale(0.232291667,0.232291667)" />
      </pattern>
    </defs>
    <rect fill={PORCELAIN} x="0" y="0" width="470" height="410" />
    <rect fill={PORCELAIN} x="0" y="0" width="470" height="310" />
    <circle fill={SILVER_SAND} cx="29" cy="16" r="4" />
    <circle fill={SILVER_SAND} cx="40" cy="16" r="4" />
    <circle fill={SILVER_SAND} cx="51" cy="16" r="4" />
  </svg>
);

MailClient.propTypes = {
  className: PropTypes.string,
};

export default MailClient;
